import { MutationTree } from 'vuex'
import { PronosticoAireState, StoreError } from '@/store/modules/pronostico-aire/types'

export const mutations: MutationTree<PronosticoAireState> = {
  PRONOSTICO_AIRE_FETCHED (state, payload: PronosticoAireState) {
    state.error = { state: false }
    state.etiqueta_list = payload.etiqueta_list
    state.estacion_id = payload.estacion_id
    state.pronostico = payload.pronostico.map((data) => ({ ...data, pronostico: data.pronostico ? { ...data.pronostico, infodata: data.pronostico.infodata2 } : null }))
    state.link_descarga = payload.link_descarga
    state.isLoaded = true
  },
  PRONOSTICO_AIRE_ERROR (state, payload: StoreError) {
    state.error = payload
  },
  PRONOSTICO_AIRE_DELETED (state) {
    state.error = { state: false }
    state.etiqueta_list = []
    state.pronostico = []
  }
}
